/**
 * The following scripts get applied on the frontend of your site.
 */

jQuery(document).ready(function ($) {

    $('#language-search').on('keyup', function () {
        var query = $(this).val().toLowerCase();

        $(this).closest('.languages').find('.language').each(function () {
            var text = $(this).text().toLowerCase();

            if (text.indexOf(query) > -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });

});